import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
export function HeroSection() {
  return <section className="relative w-full max-w-2xl mx-auto px-4 pt-12 pb-16 overflow-hidden" data-id="element-106">
      {/* Background Gradients */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[500px] h-[500px] bg-[#25F4EE]/10 rounded-full blur-[100px] -z-10" data-id="element-107" />
      <div className="absolute top-40 left-1/2 -translate-x-1/2 w-[300px] h-[300px] bg-[#FE2C55]/10 rounded-full blur-[80px] -z-10" data-id="element-108" />

      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.6
    }} className="text-center space-y-6" data-id="element-109">
        {/* Top Badge */}
        <div className="inline-block px-4 py-1.5 rounded-full bg-[#25F4EE]/10 border border-[#25F4EE]/30 backdrop-blur-sm" data-id="element-110">
          <span className="text-[#25F4EE] text-xs font-bold tracking-wide uppercase" data-id="element-111">
            Para emprendedores en EE.UU. que quieren vender en español
          </span>
        </div>

        {/* Headlines */}
        <div className="space-y-4" data-id="element-112">
          <h1 className="text-5xl md:text-7xl font-black tracking-tight leading-[0.95] text-white" data-id="element-113">
            14 días.
            <br data-id="element-114" />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#25F4EE] to-[#FE2C55]" data-id="element-115">
              1 video al día.
            </span>
            <br data-id="element-116" />
            Sin pensar tanto.
          </h1>
          <p className="text-xl md:text-2xl text-gray-300 font-medium max-w-lg mx-auto leading-relaxed" data-id="element-117">
            Si siempre empiezas fuerte y desapareces… esto es para ti.
          </p>
        </div>

        {/* Product Image */}
        <div className="relative my-10 group" data-id="element-118">
          <div className="absolute inset-0 bg-gradient-to-b from-[#25F4EE]/20 to-[#FE2C55]/20 rounded-2xl blur-xl opacity-50 group-hover:opacity-75 transition-opacity duration-500" data-id="element-119" />
          <img src="https://cdn.magicpatterns.com/uploads/hGikpRaJxRBN37T9FkdXbv/14_dias_tiktok.png" alt="TikTok Shop Afiliados en 14 Días" className="relative w-full rounded-2xl shadow-2xl border border-white/10 transform transition-transform hover:scale-[1.02] duration-500" data-id="element-120" />
        </div>

        {/* Primary CTA */}
        <a href="#comprar" onClick={e => {
        e.preventDefault();
        document.getElementById('comprar')?.scrollIntoView({
          behavior: 'smooth'
        });
      }} className="inline-flex items-center justify-center w-full md:w-auto px-8 py-4 bg-[#FE2C55] hover:bg-[#D91A40] text-white text-lg font-bold rounded-full shadow-[0_0_30px_rgba(254,44,85,0.4)] transition-all transform hover:scale-105 animate-pulse" data-id="element-121">
          Quiero mi Sprint de 14 Días — $27
          <ArrowRight className="ml-2 w-5 h-5" data-id="element-122" />
        </a>

        {/* Opening Lead */}
        <div className="mt-16 text-left space-y-6 bg-white/5 p-6 md:p-8 rounded-2xl border border-white/10" data-id="element-123">
          <p className="text-lg md:text-xl text-gray-200 leading-relaxed" data-id="element-124">
            <span className="font-bold text-[#25F4EE]" data-id="element-125">
              Te pasa lo mismo siempre.
            </span>{' '}
            Te emocionas. Guardas 12 ideas. Te imaginas las comisiones. El
            primer día publicas. El segundo también. Y el tercero… no pasa nada.
          </p>
          <p className="text-lg md:text-xl text-gray-200 leading-relaxed" data-id="element-126">
            Y ahí aparece esa sensación silenciosa:{' '}
            <span className="italic text-white" data-id="element-127">
              "capaz no sirvo para esto."
            </span>
          </p>
          <p className="text-lg md:text-xl text-gray-200 leading-relaxed" data-id="element-128">
            Entonces haces lo más lógico (y lo más peligroso): cambias de idea,
            cambias de producto, cambias de plan. No porque seas flojo. Porque
            eres impulsivo… y tu impulso te abandona cuando no hay señal rápida.
          </p>
          <p className="text-lg md:text-xl font-semibold text-white leading-relaxed border-l-4 border-[#FE2C55] pl-4" data-id="element-129">
            Este PDF no está hecho para el "disciplinado perfecto". Está hecho
            para el que empieza con fuego y luego desaparece.
          </p>
        </div>
      </motion.div>
    </section>;
}